import styled from "styled-components"
import { StatusEnum } from "./accounts"
import AddBalanceButton from "pages/accounts/components/AddBalanceButton"
import Heading from "components/Typography/Heading"
import BodyText from "components/Typography/BodyText"
import EditAccountButton from "pages/accounts/components/EditAccountButton"
import AddFreeTrialButton from "pages/accounts/components/AddFreeTrialButton"
import BlockOrActiveEnterpriseAccountButton from "pages/accounts/components/BlockOrActiveEnterpriseAccountButton"
import AccountDetailsButton from "pages/accounts/components/AccountDetailsModal/AccountDetailsButton"

export type RowType<T> = {
  value: T
}

const ActionButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 228px;
`

const ValueCell = styled.div`
  max-width: 160px;
  width: 100%;
  display: block;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;

  &.large {
    max-width: 200px;
  }
`

export const columns = [
  {
    Header: () => <Heading variant="h6">Nome</Heading>,
    Cell: (row: RowType<string>) => {
      if (row.value) {
        return (
          <ValueCell className="large">
            <BodyText size="medium" color="gray-dark">
              {row.value}
            </BodyText>
          </ValueCell>
        )
      }

      return (
        <BodyText color="error" size="semi-medium" weight="bold">
          ERRO
        </BodyText>
      )
    },
    accessor: "name"
  },
  {
    Header: () => <Heading variant="h6">Produto</Heading>,
    Cell: (row: RowType<string>) => {
      const showValue = row.value && row.value !== "undefined"

      if (showValue) {
        return (
          <BodyText size="medium" color="gray-dark">
            {row.value}
          </BodyText>
        )
      }

      return (
        <BodyText color="error" size="semi-medium" weight="bold">
          ERRO
        </BodyText>
      )
    },
    accessor: "product"
  },
  {
    Header: () => <Heading variant="h6">Status</Heading>,
    Cell: (row: RowType<string>) => {
      return (
        <BodyText size="medium" color="gray-dark">
          {StatusEnum[row.value]}
        </BodyText>
      )
    },
    accessor: "status"
  },
  {
    Header: () => <Heading variant="h6">Enterprise</Heading>,
    Cell: (row: RowType<boolean>) => {
      return (
        <BodyText size="medium" color="gray-dark">
          {row.value ? "Sim" : "Não"}
        </BodyText>
      )
    },
    accessor: "isEnterprise"
  },
  {
    Header: () => <Heading variant="h6">Plano</Heading>,
    Cell: (row: RowType<string>) => {
      return (
        <ValueCell>
          <BodyText size="medium" color="gray-dark">
            {row.value}
          </BodyText>
        </ValueCell>
      )
    },
    accessor: "purchasePlan"
  },
  {
    Header: () => <Heading variant="h6">Status do Plano</Heading>,
    Cell: (row: RowType<string>) => {
      const statusTranslation: Record<string, string> = {
        active: "Ativo",
        cancelled: "Cancelado",
        freeTrialActive: "Free Trial Ativo",
        freeTrialExpired: "Free Trial Expirado",
        blocked: "Bloqueado"
      }

      return (
        <ValueCell>
          <BodyText size="medium" color="gray-dark">
            {statusTranslation[row.value] || row.value}
          </BodyText>
        </ValueCell>
      )
    },
    accessor: "purchasePlanStatus"
  },
  {
    Header: () => <Heading variant="h6">Criado em</Heading>,
    Cell: (row: RowType<string>) => {
      return (
        <BodyText size="medium" color="gray-dark">
          {row.value}
        </BodyText>
      )
    },
    accessor: "createdAt"
  },
  {
    Header: () => <Heading variant="h6">Atualizado em</Heading>,
    Cell: (row: RowType<string>) => {
      return (
        <BodyText size="medium" color="gray-dark">
          {row.value}
        </BodyText>
      )
    },
    accessor: "updatedAt"
  },
  {
    Header: () => <Heading variant="h6">Ações</Heading>,
    id: "action",
    Cell: (value: any) => {
      return (
        <ActionButtons>
          <EditAccountButton account={value.cell.row.original} />
          <AddBalanceButton account={value.cell.row.original} />
          <AddFreeTrialButton account={value.cell.row.original} />
          <BlockOrActiveEnterpriseAccountButton account={value.cell.row.original} />
          <AccountDetailsButton account={value.cell.row.original} />
        </ActionButtons>
      )
    }
  }
]
